import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimJobComment.List.IRequest;
type Response = Api.Core.ClaimJobComment.List.IResponse;
type Headers = Api.Core.ClaimJobComment.List.IHeaders;
const url = '/api/Claims/ClaimJobComment';
export default async function claimJobCommentListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
